export default [
    {
        path: "/agent/xhs/list",
        name: "agent-xhs-list",
        component: () => import("@/views/agent/xhs/list.vue"),
    },
    {
        path: "/agent/xhs/create",
        name: "agent-xhs-create",
        component: () => import("@/views/agent/xhs/create.vue"),
    },
    {
        path: "/agent/bot/list",
        name: "agent-bot-list",
        component: () => import("@/views/agent/bot/list.vue"),
    },
    {
        path: "/agent/bot/view",
        name: "agent-bot-view",
        component: () => import("@/views/agent/bot/view.vue"),
    },
    {
        path: "/agent/bot/chat",
        name: "agent-bot-chat",
        component: () => import("@/views/agent/bot/chat.vue"),
    },
    {
        path: "/agent/knowledge/list",
        name: "agent-knowledge-list",
        component: () => import("@/views/agent/knowledge/list.vue"),
    },
    {
        path: "/agent/knowledge/view",
        name: "agent-knowledge-view",
        component: () => import("@/views/agent/knowledge/view.vue"),
    },
    {
        path: "/agent/knowledge/unit/create",
        name: "agent-knowledge-unit-create",
        component: () => import("@/views/agent/knowledge/unit/create.vue"),
    },
    {
        path: "/agent/knowledge/unit/view",
        name: "agent-knowledge-unit-view",
        component: () => import("@/views/agent/knowledge/unit/view.vue"),
    },
    {
        path: "/agent/xhsad/list",
        name: "agent-xhsad-list",
        component: () => import("@/views/agent/xhsad/list.vue"),
    },
    {
        path: "/agent/xhsad/new",
        name: "agent-xhsad-new",
        component: () => import("@/views/agent/xhsad/new.vue"),
    },
    {
        path: "/agent/xhsflow/dashboard",
        name: "agent-xhsflow-dashboard",
        component: () => import("@/views/agent/xhsflow/dashboard.vue"),
    },
    {
        path: "/agent/xhsflow/strategy/brand/list",
        name: "agent-xhsflow-strategy-brand-list",
        component: () => import("@/views/agent/xhsflow/strategy/brand_list.vue"),
    },
    {
        path: "/agent/xhsflow/strategy/brand/new",
        name: "agent-xhsflow-strategy-brand-new",
        component: () => import("@/views/agent/xhsflow/strategy/brand_new.vue"),
    },
    {
        path: "/agent/xhsflow/strategy/account/list",
        name: "agent-xhsflow-strategy-account-list",
        component: () => import("@/views/agent/xhsflow/strategy/account_list.vue"),
    },
    {
        path: "/agent/xhsflow/strategy/account/new",
        name: "agent-xhsflow-strategy-account-new",
        component: () => import("@/views/agent/xhsflow/strategy/account_new.vue"),
    },
    {
        path: "/agent/xhsflow/strategy/content/list",
        name: "agent-xhsflow-strategy-content-list",
        component: () => import("@/views/agent/xhsflow/strategy/content_list.vue"),
    },
    {
        path: "/agent/xhsflow/strategy/content/new",
        name: "agent-xhsflow-strategy-content-new",
        component: () => import("@/views/agent/xhsflow/strategy/content_new.vue"),
    },

    // xhs account
    {
        path: "/agent/xhsaccount/list",
        name: "agent-xhsaccount-list",
        component: () => import("@/views/agent/xhsaccount/list.vue"),
    },
    {
        path: "/agent/xhsaccount/view",
        name: "agent-xhsaccount-view",
        component: () => import("@/views/agent/xhsaccount/view.vue"),
    },

    // flow
    {
        path: "/agent/flow/dashboard",
        name: "agent-flow-dashboard",
        component: () => import("@/views/agent/flow/list.vue"),
    },
    {
        path: "/agent/flow/chat",
        name: "agent-flow-chat",
        component: () => import("@/views/agent/flow/chat.vue"),
    },
    {
        path: "/agent/flow/history",
        name: "agent-flow-history",
        component: () => import("@/views/agent/flow/history.vue"),
    },
]